module.exports = __webpack_public_path__ + "img/xun_icon3.ab28ed20.png";